import { argsOrArgArray } from '../util/argsOrArgArray';
import { raceWith } from './raceWith';
export function race(...args) {
    return raceWith(...argsOrArgArray(args));
}
